import { NthOrderInterface } from "@/model/components/NthOrderInterface.ts";
import {
  DELIVERY_ADDRESS,
  REPEAT_DELIVERY_ADDRESS,
  MANUSCRIPT_DELIVERY_ADDRESS,
  DELIVERY_METHOD,
  PAYMENT_METHOD
} from "@/model/delivery.ts";

/**
 * Availability Of Options
 */

// 名刺ケース
export function optionCardCaseShow(nthOrderList: NthOrderInterface[]): boolean {
  let result = false;
  for (let i = 0; i < nthOrderList.length; i++) {
    if (Number(nthOrderList[i].numberOfPrints) > 30) {
      result = true;
    }
  }
  return result;
}

// ロゴトレース
export function optionTraceShow(
  frontSideLogo: boolean,
  backSideLogo: boolean,
  freeBackSideLogo: boolean
): boolean {
  return Boolean(frontSideLogo || backSideLogo || freeBackSideLogo);
}

/**
 * Order Details
 */

// 変更箇所
export function orderChangeShow(change: string) {
  return change === "変更する";
}

/**
 * Product Delivery Address
 */

// 別のご住所へお届け入力欄
export function otherContactAresShow(deliveryAddress: string): boolean {
  return [
    DELIVERY_ADDRESS.OTHER_ADDRESS,
    REPEAT_DELIVERY_ADDRESS.OTHER_ADDRESS,
    MANUSCRIPT_DELIVERY_ADDRESS.OTHER_ADDRESS
  ].includes(deliveryAddress);
}

// ご来店受け取り入力欄
export function storeContactAresShow(deliveryAddress: string): boolean {
  return deliveryAddress === DELIVERY_ADDRESS.AT_THE_STORE;
}

/**
 * Product Delivery Method
 */

// お届け方法
export function deliveryMethod(deliveryAddress: string): boolean {
  return deliveryAddress !== DELIVERY_ADDRESS.AT_THE_STORE;
}

// お届け時間指定
export function deliveryTimeShow(deliveryMethod: string): boolean {
  return deliveryMethod === DELIVERY_METHOD.YAMATO;
}

/**
 * Payment Method
 */

// クレジットカード入力欄
export function creditCardAresShow(deliveryMethod: string): boolean {
  return deliveryMethod === PAYMENT_METHOD.CREDIT_CARD;
}

// コンビニ決済
export function convenienceStoreShow(deliveryAddress: string): boolean {
  return deliveryAddress !== DELIVERY_ADDRESS.AT_THE_STORE;
}

// 銀行・郵便振込
export function bankShow(deliveryAddress: string): boolean {
  return deliveryAddress !== DELIVERY_ADDRESS.AT_THE_STORE;
}

// 代金引換
export function cashOnDeliveryShow(
  deliveryAddress: string,
  deliveryMethod: string
): boolean {
  return (
    deliveryAddress !== DELIVERY_ADDRESS.AT_THE_STORE &&
    deliveryMethod === DELIVERY_METHOD.YAMATO
  );
}

// ご来店現金払い
export function shopByShow(deliveryAddress: string): boolean {
  return deliveryAddress === DELIVERY_ADDRESS.AT_THE_STORE;
}

/**
 * Confirmation Of The Finished Image
 */

// FAX入力欄
export function faxShow(confirmationMethod: string): boolean {
  return confirmationMethod === "FAXで確認する";
}
